export default __webpack_public_path__ + "static/media/The August Ones' Impassible Grin.89afdad3.jpg";